import { Container, FlexProps } from '@chakra-ui/react'
import { Footer, Nav } from 'components'
import * as React from 'react'
import { Helmet } from 'react-helmet'

type PageWrapProps = FlexProps & {
  title: string
  withNav?: boolean
  withFooter?: boolean
}

const PageWrap: React.FC<PageWrapProps> = ({ children, title, withNav, withFooter, ...rest }) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {withNav && <Nav />}
      <Container maxW="container.xl" {...rest}>
        {children}
      </Container>
      {withFooter && <Footer />}
    </>
  )
}

PageWrap.defaultProps = {
  pt: 8,
  flex: 1,
  height: '100%',
  flexDir: 'column',
  minHeight: '50vh',
  align: 'flex-start',
  justify: 'flex-start',
  withNav: true,
  withFooter: true
}

export default PageWrap
